export default function Button(props: { text: string }) {
    return (
        <span className="button">{props.text}</span>
    );
}